<template>
  <div class="container mt-3">
    <b-breadcrumb :items="crumbs" class="mb-3"></b-breadcrumb>
    <div v-if="users.length===0" class="text-muted small">暂无数据</div>
    <div v-for="u in users" :key="u.id" class="p-2 mb-2 border rounded d-flex align-items-center justify-content-between">
      <div class="d-flex align-items-center">
        <div class="avatar-wrap mr-2 clickable" @click="goUser(u.id)">
          <img v-if="u.avatar_url" :src="full(u.avatar_url)" class="avatar" />
          <div v-else class="avatar-fallback">{{ initial(u.user_nick || u.user_name) }}</div>
        </div>
        <div class="clickable" @click="goUser(u.id)">
          <div class="font-weight-bold">{{ u.user_nick || u.user_name }}</div>
          <div class="text-muted small">粉丝 {{ u.followers || 0 }}</div>
          <div class="text-muted small" v-if="u.bio">{{ u.bio }}</div>
        </div>
      </div>
      <div>
        <b-button size="sm" :variant="u.followed_by_me ? 'secondary' : 'primary'" @click="toggle(u)">{{ u.followed_by_me ? '已关注' : '关注' }}</b-button>
      </div>
    </div>
  </div>
</template>

<script>
import { request_zzquant } from 'network/request.js'
export default {
  data(){ return { users:[], title:'关注列表', crumbs:[] } },
  mounted(){ this.load() },
  beforeRouteUpdate(to, from, next){ this.load(); next() },
  methods:{
    async load(){
      const id = this.$route.params && this.$route.params.id ? parseInt(this.$route.params.id) : 0
      const type = (this.$route.query && this.$route.query.type) ? String(this.$route.query.type) : ''
      const isFans = type === 'fans'
      this.title = isFans ? '粉丝列表' : '关注列表'
      this.crumbs = [ { text:'首页', to:'/home' }, { text:'个人主页', to:'/user/home/'+id }, { text: this.title, active:true } ]
      if (!id) { this.users = []; return }
      if (isFans) {
        await this.loadFans(id)
      } else {
        await this.loadFollowings(id)
      }
    },
    async loadFollowings(id){
      try{
        const res = await request_zzquant({ url: '/user/followings/' + id })
        const arr = res && res.data && res.data.data ? res.data.data : []
        this.users = Array.isArray(arr) ? arr : []
      }catch(e){ this.users = [] }
    },
    async loadFans(id){
      const candidates = [
        '/user/followers/' + id,
        '/user/fans/' + id,
        '/user/follower/list/' + id,
        '/user/fans/list/' + id,
        '/user/followers?id=' + id
      ]
      for (let i = 0; i < candidates.length; i++){
        const url = candidates[i]
        try{
          const res = await request_zzquant({ url })
          const code = res && res.data ? res.data.code : null
          const arr = res && res.data && res.data.data ? res.data.data : []
          this.users = Array.isArray(arr) ? arr : []
          if (code === 20000) { break }
        }catch(e){ /* try next */ }
      }
    },
    initial(name){ const s=String(name||'').trim(); return s? s.substr(0,1): '?' },
    toggle(u){ request_zzquant({ url:'/user/follow/toggle', method:'POST', data:{ target_user_id: u.id } }).then(res=>{ const d=res.data&&res.data.data?res.data.data:{}; u.followed_by_me = !!d.followed; u.followers = d.followers || u.followers }) },
    full(u){ if(!u) return ''; if(String(u).startsWith('http')) return u; return 'https://api.zizizaizai.com'+u },
    goUser(id){ if(!id) return; this.$router.push('/user/home/'+id) }
  }
}
</script>

<style>
.avatar{ width:32px; height:32px; border-radius:50%; object-fit:cover; border:1px solid #eee; }
.avatar-fallback{ width:32px; height:32px; border-radius:50%; background:#f0f0f0; border:1px solid #ddd; display:flex; align-items:center; justify-content:center; color:#333; font-weight:600; }
.clickable{ cursor:pointer; }
</style>
